import { NavLink } from 'react-router-dom';
import { Home, Globe, Users, Menu, type LucideIcon } from 'lucide-react';
import { coreNavItems } from '../../lib/panelNavigation';
import { useSubmissionsUnread } from '../../lib/useSubmissionsUnread';

const DOCK_ICON: Record<string, LucideIcon> = {
  dashboard: Home,
  site: Globe,
  contacts: Users,
};

/**
 * Dock inferior mobile (sección 7.4): máximo 4 tabs. Los tres primeros salen
 * del catálogo de navegación (mobileTab); 'Más' abre el drawer existente para
 * la navegación profunda. Oculto en desktop.
 */
export default function MobileDock({ onOpenMore }: { onOpenMore: () => void }) {
  const tabs = coreNavItems.filter((item) => item.mobileTab);
  // CLI-30 — "Mensajes" no es tab propio (se respeta el máximo de 4), pero su badge
  // no puede desaparecer solo por vivir en el drawer: se refleja aquí.
  const { unreadCount: messagesUnread } = useSubmissionsUnread();

  const tabClass = ({ isActive }: { isActive: boolean }) =>
    `relative flex flex-col items-center justify-center gap-0.5 flex-1 py-1.5 text-xs transition-colors ${
      isActive ? 'text-ui-accent' : 'text-ui-text-subtle hover:text-ui-text'
    }`;

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-dropdown flex items-stretch border-t border-ui-border bg-ui-surface/95 backdrop-blur-sm pb-[env(safe-area-inset-bottom)]"
      aria-label="Navegación principal"
    >
      {tabs.map((item) => {
        const Icon = DOCK_ICON[item.id] ?? Home;
        return (
          <NavLink key={item.id} to={item.to} end={item.id === 'dashboard'} className={tabClass}>
            <span className="relative">
              <Icon size={20} strokeWidth={1.85} />
            </span>
            {item.label}
          </NavLink>
        );
      })}
      <button type="button" onClick={onOpenMore} className={tabClass({ isActive: false })}>
        <span className="relative">
          <Menu size={20} strokeWidth={1.85} />
          {messagesUnread > 0 && (
            <span className="absolute -top-1.5 -right-2 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-ui-accent px-1 text-xs font-semibold leading-none text-ui-bg">
              {messagesUnread > 9 ? '9+' : messagesUnread}
            </span>
          )}
        </span>
        Más
      </button>
    </nav>
  );
}
